export const SET_GIGREQUEST_FORM = 'GIGREQUEST/SET_FORM'
export const RESET_GIGREQUEST_FORM = 'GIGREQUEST/RESET_FORM'

export const SET_FORM_ARTIST = 'GIGREQUEST/SET_FORM_ARTIST'
export const SET_FORM_EVENT = 'GIGREQUEST/SET_FORM_EVENT'
export const SET_FORM_REQUESTER = 'GIGREQUEST/SET_FORM_REQUESTER'
export const SET_FORM_REQUEST_ID = 'GIGREQUEST/SET_FORM_REQUEST_ID'
